import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex gap-4',
    price: '',
    oldPrice: 'text-text-inactive line-through'
  },
  variants: {},
  defaultVariants: {}
});
